import { useEffect, useRef } from "react";
import { POLL_INTERVAL_MS } from "../../shared/constants";

export function usePolling(
  callback: () => void | Promise<void>,
  enabled: boolean,
  intervalMs: number = POLL_INTERVAL_MS
) {
  const saved = useRef(callback);
  saved.current = callback;

  useEffect(() => {
    if (!enabled) return;
    const id = setInterval(() => saved.current(), intervalMs);
    return () => clearInterval(id);
  }, [enabled, intervalMs]);
}
